import React from "react";

export const BookingWidget = () => {
  return null;
};
